import { render, staticRenderFns } from "./GlobalSpecsButton.vue?vue&type=template&id=c914e138&"
import script from "./GlobalSpecsButton.vue?vue&type=script&lang=js&"
export * from "./GlobalSpecsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports